import React from "react";
import { Route, Switch } from "react-router-dom";
import EnquiriesList from "./EnquiriesList";
import EnquiryDetails from "./EnquiryDetails";
import ViewQuotationAdmin from "./ViewQuotationAdmin";
import QuotationDetailsAdmin from "./QuotationDetailsAdmin";
import ViewProfileAdmin from "./ViewProfileAdmin";
import ReplyWithQuotation from "./ReplywithQuotation";
import AdminQuotationList from "./AdminQuotationList";
import AdminQuotationDetails from "./AdminQuotationDetails";

const App = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}`} component={EnquiriesList} />
    <Route path={`${match.url}/details`} component={EnquiryDetails} />
    <Route path={`${match.url}/view-quotations-list`} component={ViewQuotationAdmin} />
    <Route path={`${match.url}/view-quotations-details`} component={QuotationDetailsAdmin}/>
    <Route path={`${match.url}/view-profile`} component={ViewProfileAdmin}/>
    <Route path={`${match.url}/reply-with-quotations`} component={ReplyWithQuotation}/>
    <Route path={`${match.url}/view-admin-quotations-list/:id?`} component={AdminQuotationList}/>
    <Route path={`${match.url}/quotations-details/:id?`} component={AdminQuotationDetails}/>
    
  </Switch>
);

export default App;
